<template>
  <ul class="course_list" >
    <item :item="item" v-for="(item,idx) in list" :configs="configs" :key="item.id" />
  </ul>
</template>

<script>
import item from "./item.vue";
export default {
  props: {
    list: {
      type: Array
    },
    configs: {
      type: Object,
      default() {
        return {
          progress: false
        };
      }
    }
  },

  components: {
    item
  }
};
</script>

<style lang="scss" scoped>
.course_list {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 46px;
}
</style>